import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/Button.tsx";
import {styled} from "styled-components";

const MenuContainer = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 150px;
`;

const MenuItem = styled.div<{ $isSelected?: boolean }>`
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: ${props => props.$isSelected ? '#4D699C' : '#333'};
  background: ${props => props.$isSelected ? 'rgba(77, 105, 156, 0.1)' : 'transparent'};
  
  &:hover {
    background: rgba(77, 105, 156, 0.1);
  }
`;

interface SelectAsLink {
    items: Array<{label: string, value: string | number }>
    label: string;
    value: string | number | undefined;
    onSelect: (value: string | number) => void;
    disabled?: boolean
}

export const SelectAsLink = ({
    items,
    label,
    value,
    onSelect,
    disabled
}: SelectAsLink) => {
    const [isVisible, setIsVisible] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    const handleSelect = (value: string | number) => {
        setIsVisible(false);
        onSelect(value)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsVisible(false); // Закрываем меню
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div>
            <Button
                variant="link"
                padding="3px 10px"
                style={{ fontSize: '14px', minWidth: 'max-content' }}
                className="operator-button"
                disabled={disabled}
                onClick={() => setIsVisible(true)}
            >
                {value ?? label}
            </Button>
            {isVisible && (
                <div className="operator-context-menu operator-menu" ref={menuRef}>
                    <MenuContainer
                        className="operator-menu"
                        tabIndex={0}
                    >
                        {items.map(item => (
                            <MenuItem
                                key={item.value}
                                $isSelected={item.value === value}
                                onClick={() => handleSelect(item.value)}
                            >
                                {item.label}
                            </MenuItem>
                        ))}
                    </MenuContainer>
                </div>
            )}
        </div>
    );
};
